import { Injectable } from '@angular/core';

import { CameraOptions, Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceService } from '../device-service/device-service';
import { DeviceInfo } from '../../data/device-info';
import { Platform } from '@ionic/angular';
import { Custom_RequestMethod } from '../common-service';
/*
 Generated class for the ImageService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class ImageService {
    deviceInfo: DeviceInfo;
    constructor(
        // private camera: Camera,
        private deviceService: DeviceService,
        private platform: Platform,
        private requestMethod: Custom_RequestMethod) {
        // if(this.platform.is('capacitor')) {
        this.deviceService.getDeviceInfo().then((devInfo: DeviceInfo) => {
            this.deviceInfo = devInfo;
        })
        // }
    }

    public checkVersion() {
        let _version = '9'; '9.12-update';
        let _splitter;
        _splitter = (_version.split(".", 1)) ? _version.split(".", 1) : _version;

        if (this.deviceInfo) {
            console.debug("platform version : ", this.deviceInfo.platformVersion);
        }
    }

    /**
     * Capture an image
     * @param highQuality Whether to capture the high quality image.
     * @returns {Observable<R>}
     */
    public captureImage(highQuality: boolean,
        encodingType: number = 0): Observable<ImageData> {
        let _allowEdit;
        let _version;
        let _platformVersion;
        if (this.platform.is('capacitor') && this.deviceInfo) {
            _platformVersion = (this.deviceInfo.platformVersion.split(".", 1)) ? this.deviceInfo.platformVersion.split(".", 1)[0] : this.deviceInfo.platformVersion;
            _version = _platformVersion;
        }
        _allowEdit = _version <= 10 ? true : false;
        let options: CameraOptions = {
            quality: (highQuality) ? 100 : 50,
            allowEdit: _allowEdit,
            sourceType: 1,
            destinationType: 2,
            correctOrientation: true,
            saveToPhotoAlbum: false,
            encodingType: encodingType
        }
        return this._getImage(options);
    }

    /**
     * Pick an image from photo library
     * @returns {Observable<ImageData>}
     */
    public pickImage(encodingType: number = 0): Observable<ImageData> {
        let _allowEdit;
        let _version;
        let _platformVersion;
        if (this.platform.is('capacitor') && this.deviceInfo) {
            _platformVersion = (this.deviceInfo.platformVersion.split(".", 1)) ? this.deviceInfo.platformVersion.split(".", 1)[0] : this.deviceInfo.platformVersion;
            _version = _platformVersion;
        }
        _allowEdit = _version <= 10 ? true : false;
        let options: CameraOptions = {
            allowEdit: _allowEdit,
            sourceType: 2,
            destinationType: 2,
            correctOrientation: true,
            saveToPhotoAlbum: false,
            encodingType: encodingType
        }
        return this._getImage(options);
    }

    /**
     * Get the image from photo library
     * @param options The camera options
     * @returns {any}
     * @private
     */
    private _getImage(options: CameraOptions): Observable<ImageData> {
        let promise: Promise<ImageData> = null


        // this.camera.getPicture(options)
        //                                         .then((imageUrl: string) => {
        //                                             let name     = imageUrl.substr(imageUrl.lastIndexOf('/') + 1);
        //                                             let namePath = imageUrl.substr(0, imageUrl.lastIndexOf('/') + 1);
        //                                             return {
        //                                                 originalURL: imageUrl,
        //                                                 imageName  : name,
        //                                                 imagePath  : namePath
        //                                             }
        //                                         });
        return from(promise)
            .pipe(map((data: ImageData) => {
                return data;
            }));


    }

}

export interface ImageData {
    originalURL: string;
    imageName?: string;
    imagePath?: string;
}

